export default __webpack_public_path__ + "static/media/painting-house.03560aef.jpeg";